/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Absences_EndInputs */

const en_tables_absences_end = /** @type {(inputs: Tables_Absences_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

const de_tables_absences_end = /** @type {(inputs: Tables_Absences_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende`)
};

/**
* | output |
* | --- |
* | "End" |
*
* @param {Tables_Absences_EndInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_absences_end = /** @type {((inputs?: Tables_Absences_EndInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Absences_EndInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_absences_end(inputs)
	return de_tables_absences_end(inputs)
});